import MailmagazineCompleted from './MailmagazineCompleted'

export default MailmagazineCompleted
